import React, { useCallback } from "react";
import DroneNestForm from "./DroneNestForm";
import FloorView from "../FloorView";
import {
  staticVar,
  useActiveCampusContext,
  useActiveDroneNestContext,
  useActiveFloorContext,
} from "../Constant";
import CampusTitle from "../../CampusTitle";
import { Stack } from "@mui/material";
import { Footer } from "../../../Footer";
import StyledButton from "../../../../../Reuse/UI/StyledButton";
import { useNavigate } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useDialog } from "../../../../../context";

const DroneNest = () => {
  const navigate = useNavigate();
  const { showInfo } = useDialog();
  const { activeDroneNest } = useActiveDroneNestContext();
  const { activeCampus } = useActiveCampusContext();
  const { action } = useActiveFloorContext();

  const checkActiveDroneNest = useCallback(
    (value) => {
      if (!!activeDroneNest?.id && action.isDirty) {
        showInfo(staticVar.info);
      } else {
        navigate(value);
      }
    },
    [navigate, showInfo, activeDroneNest, action]
  );


  return (
    <React.Fragment>
      <Stack direction={"row"}>
        <Stack
          direction={"row"}
          gap={1}
          alignItems={"center"}
          sx={{ flexGrow: 1, width: 0 }}
        >
          <CampusTitle
            name={activeCampus?.name}
            index={activeCampus?.campus_number}
            variant={"h1"}
            // sx={{ width: 0, flexGrow: 1 }}
          />
        </Stack>
      </Stack>
      <Stack
        direction={"row"}
        gap={1}
        sx={{ flexGrow: 1, maxHeight: "calc(100% - 100px)" }}
      >
        <FloorView showFooter={true} />
        {!!activeDroneNest?.id &&<DroneNestForm />}
        <Footer>
          <Stack
            display="flex"
            flexDirection={"row"}
            justifyContent="flex-end"
            gap={1}
            sx={{ paddingX: 2, width: "100%" }}
          >
            <StyledButton
              variant="outlined"
              startIcon={<ArrowLeftOutlined />}
              onClick={() => checkActiveDroneNest("../edit")}
            >
              Back
            </StyledButton>
            <StyledButton variant="contained" onClick={() => checkActiveDroneNest("..")}>
              Complete
            </StyledButton>
          </Stack>
        </Footer>
      </Stack>
    </React.Fragment>
  );
};

export default React.memo(DroneNest);
